<template>
  <SignInSignUpLayout>
    <div class="sing-in-form">
      <template v-if="!emailResent">
        <h1 class="sign-in-title text-left">
          Hi! Confirm your email and start using EasyAgency.
        </h1>

        <div class="step-text">
          We sent an email to {{ email }}. <br />
          Didn't get an email?
        </div>

        <b-button @click="resendEmail" class="button" variant="light">
          <div v-if="isLoading" class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <template v-else>
            <span class="material-icons resend-icon">
              replay
            </span>
            Resend
          </template>
        </b-button>

        <div class="sign-with">
          <span class="text">Next steps</span>
        </div>

        <div class="d-flex flex-column">
          <span class="step-text">1. Verify your account</span>
          <span class="step-text mb-4">Click on the link in the email to verify your account.</span>
          <span class="step-text">2. Start using EasyAgency</span>
          <span class="step-text">Log in to and start exploring features.</span>
        </div>
      </template>

      <div v-else>
        <template v-if="isVerificationFailed">
          <span class="material-symbols-outlined icon error-icon">
            error
          </span>
          <p class="verification-title">Verification Failed</p>

          <p class="verification-text">
            It looks like you’ve attempted email verification too many times.
          </p>
          <p class="verification-text">
            Still haven’t received the verification email?
          </p>
          <ul style="margin: 0; padding-left: 20px;">
            <li>Check your spam or junk folder.</li>
            <li>Ensure your email server isn’t blocking messages from us.</li>
            <li>If you’re using a work email, check with your IT team about firewall settings.</li>
          </ul>

          <p class="verification-text" style="margin-top: 10px;">
            If you’re still having trouble, please contact us at <a
              href="mailto:support@easyagency.io">support@easyagency.io</a> for assistance.
          </p>

        </template>
        <template v-else>
          <span class="material-symbols-outlined icon success-icon">
            check_circle
          </span>
          <p class="verification-title">Confirmation Email Sent</p>
          <p class="verification-text">
            We’ve re-sent the confirmation email to {{ email }}.<br />
            Please check your email and follow the instructions to confirm your account.
          </p>

          <b-button @click="resendEmail" :disabled="resentTimer > 0" class="button" variant="light">
            <div v-if="isLoading" class="spinner-border text-primary" role="status">
              <span class="sr-only">Loading...</span>
            </div> <template v-else>
              <span class="material-icons resend-icon">
                replay
              </span>
              Resend again
            </template>
          </b-button>
          <div v-if="resentTimer" class="resend-text">Resend confirmation email after {{ resentTimer }} sec</div>
        </template>
      </div>

      <!-- <SuccessView v-else title="Confirmation Email Sent">
        <p>We've re-sent the confirmation email to your inbox. Please check your email and follow the instructions to confirm your account.</p>
      </SuccessView> -->
    </div>
  </SignInSignUpLayout>
</template>

<script>
import SignUp from '@mixins/SignUp'
import SignInSignUpLayout from '@components/sign-up/SignInSignUpLayout.vue'
// import SuccessView from '@components/sign-up/SuccessView.vue'

export default {
  name: 'confirmEmail',
  mixins: [ SignUp ],
  components: { SignInSignUpLayout },
  data () {
    return {
      email: '',
      prefix: '',
      emailResent: false,
      resentCounter: 0,
      isVerificationFailed: false,
      resentTimer: 0,
      isLoading: false
    }
  },
  created () {
    const tenantSignUp = this.getTenantSignUpData()
    if (tenantSignUp) {
      this.email = tenantSignUp.email
      this.prefix = tenantSignUp.prefix
    } else {
      this.$router.replace({ name: this.ROUTES.SIGN_UP.name })
    }
  },
  watch: {
    resentCounter (newVal) {
      if (newVal > 1) {
        this.resentTimer = 60
        const interval = setInterval(() => {
          this.resentTimer -= 1
          if (this.resentTimer <= 0) {
            clearInterval(interval)
          }
        }, 1000)
      }

      if (newVal > 3) {
        this.isVerificationFailed = true
      }
    }
  },
  methods: {
    resendEmail () {
      this.isLoading = true
      this.axios
        .post('/api/register/resend-email', {
          email: this.email,
          prefix: this.prefix
        })
        .then(() => {
          this.emailResent = true
          this.resentCounter += 1
        })
        .catch((err) => {
          if (err.response.data.errors) {
            this.errorNotifications(err)
          }
        }).finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
.step-text {
  font-weight: 500;
  font-size: 18px;
  text-align: left;
  width: 100%;
  display: block;
  line-height: 20.68px;
  color: $fontColorBase;
}

.btn.btn-light {
  border: 1px solid $fontColorAccent;
}

.resend-btn {
  color: $fontColorAccent;
  border: 1px solid $fontColorAccent;
  font-weight: 700;
  background-color: #fff;
  font-size: 14px;
  border-radius: 8px;
  padding: 12px 28px;
  text-transform: uppercase;
}

.resend-icon {
  font-weight: 600;
  width: 20px;
  height: 20px;
}

.icon {
  font-size: 6rem;
  &.success-icon {
    color: $iconColorSuccess;
  }
  &.error-icon {
    color: $iconColorError;
  }
}

.verification-title {
  font-family: Ubuntu;
  font-size: 30px;
  font-style: normal;
  font-weight: 700;
  line-height: 48px;
  margin: 30px 0;
}

.verification-text {
  font-family: Ubuntu;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  margin-bottom: 30px;
}

.resend-text {
  margin-top: 30px;
  font-family: Ubuntu;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.button.disabled {
  background-color: unset !important;
  color: unset !important;
  // border: 1px solid $fontColorAccent;
}

</style>
